module.exports = "//static.hsappstatic.net/ui-images/static-2.345/optimized/transparent_background.svg"